<script>
  import IntersectionObserver from "svelte-intersection-observer";

  let element;
  export let intersecting = false;

  import DepartmentWithIcon from "./DepartmentWithIcon.svelte";
  import Emoji from "@helpers/Emoji.svelte";
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="intro-to-fund">
    <div class="prose">
      <h1 class="section-title">
        What can <span class="accent-text"
          >$5.1B <span class="emoji-follows" data-emoji="💪"
            >do?<Emoji emoji="flex" /></span
          >
        </span>
      </h1>
      <p class="body-text">
        $5.1 billion funds 28 departments in the City of Houston, to provide
        services such as:
      </p>
      <div class="three-icons">
        <DepartmentWithIcon department="Parks and Recreation" emoji="slide" />
        <DepartmentWithIcon department="Library" emoji="books" />
        <DepartmentWithIcon department="Solid Waste Management" emoji="trash" />
      </div>
      <p class="body-text">
        and many more. The funds for these services come from <strong
          >your</strong
        > tax dollars.
      </p>
      <!-- MINOR FIXME: One more sentence about sources? -->
      <p class="body-text">
        Let's communicate what we want to see in your budget.
      </p>
    </div>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .emoji-follows::before {
    bottom: -0.75rem;
    right: -5rem;
  }

  .three-icons {
    display: flex;
    margin: 2rem 0 2rem 0;
  }
</style>
